import apiClient from './apiClient';
import { API_URL } from '../config';

export interface LogEntry {
  timestamp: string;
  level: string;
  module?: string;
  message: string;
  source?: string;
}

/**
 * Fetch backend log entries (admin only).
 */
const getBackendLogs = async (
  limit = 200,
  level?: string,
): Promise<LogEntry[]> => {
  const params: Record<string, string | number> = { limit };
  if (level) params.level = level;
  const resp = await apiClient.get<LogEntry[]>(`${API_URL}/admin/logs/backend`, { params });
  return resp.data;
};

/**
 * Fetch frontend log entries from server buffer (admin only).
 */
const getFrontendLogs = async (
  limit = 200,
  level?: string,
): Promise<LogEntry[]> => {
  const params: Record<string, string | number> = { limit };
  if (level) params.level = level;
  const resp = await apiClient.get<LogEntry[]>(`${API_URL}/admin/logs/frontend`, { params });
  return resp.data;
};

/**
 * Post frontend log entries to server buffer (admin only).
 */
const postFrontendLogs = async (logs: LogEntry[]): Promise<void> => {
  await apiClient.post(`${API_URL}/admin/logs/frontend`, { logs });
};

/**
 * Download complete backend log file (admin only).
 */
const downloadBackendLogFile = async (): Promise<void> => {
  const resp = await apiClient.get(`${API_URL}/admin/logs/backend/download`, {
    responseType: 'blob',
  });
  const blob = new Blob([resp.data], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `backend_logs_full_${new Date().toISOString().slice(0, 10)}.txt`;
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * Download complete frontend log file from server buffer (admin only).
 */
const downloadFrontendLogFile = async (): Promise<void> => {
  const resp = await apiClient.get(`${API_URL}/admin/logs/frontend/download`, {
    responseType: 'blob',
  });
  const blob = new Blob([resp.data], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `frontend_logs_full_${new Date().toISOString().slice(0, 10)}.txt`;
  a.click();
  URL.revokeObjectURL(url);
};

export default { 
  getBackendLogs, 
  getFrontendLogs, 
  postFrontendLogs,
  downloadBackendLogFile,
  downloadFrontendLogFile,
};
